import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import { mapValues } from 'lodash';
import { ResponsiveTabs } from 'legacy-packages/ft-cb';
import VideoItem from './VideoItem';
import breakpoints from 'legacy-styles/utility/Breakpoints.module.scss';
import './styles.scss';

const { mobile } = mapValues(breakpoints, Number);

const VideosCarousel = (props) => {
  const {
    items,
    activeResourceId,
    onVideoChange,
    isStudent,
    isTeacher,
    studentClasses,
    subjectId,
    filteredClasses,
    apdCarouselData,
  } = props;
  const initItem = items.find(
    (item) => (item.resourceId || item.id) === activeResourceId,
  );
  const { innerWidth: windowWidth } = window;
  const isMobile = windowWidth <= mobile;
  const tabWidth = isMobile ? 210 : 232.33;
  const initTabIndex = items.indexOf(initItem) + 1;
  const responsiveTabsExtraProps = isMobile
    ? {}
    : {
        tabWidth,
      };
  const responsiveTabsRef = useRef(null);

  useEffect(() => {
    if (responsiveTabsRef.current) {
      responsiveTabsRef.current.doResize();
    }
  }, [items]);

  const viewVideo = (activeVideoOrder) => {
    const activeVideoIndex = activeVideoOrder - 1;
    const activeVideo = items[activeVideoIndex];
    onVideoChange(activeVideo);
  };

  const renderVideo = (tabOrder) => {
    const tabIndex = tabOrder - 1;
    const {
      id,
      resourceId,
      displayName,
      description,
      thumbnailUrl,
      url,
      unitId,
    } = items[tabIndex];
    const progress = get(
      apdCarouselData,
      [subjectId, url, 'playTimePercentage'],
      0,
    );

    return (
      <VideoItem
        id={id}
        title={displayName}
        description={description}
        thumbnailUrl={thumbnailUrl}
        providerId={url}
        scope={[
          'units',
          `unit-${unitId}`,
          'resources',
          `resource-${resourceId || id}-subject-${subjectId}`,
        ]}
        studentClasses={studentClasses}
        isStudent={isStudent}
        isTeacher={isTeacher}
        width={tabWidth - 32} // 32px are the margins and the paddings.
        progressPercentage={(progress === 1 && 0) || progress * 100}
        filteredClasses={filteredClasses}
      />
    );
  };

  return (
    <div className="ft-videos-carousel">
      <ResponsiveTabs
        ref={responsiveTabsRef}
        ariaLabelPrevTab="Go to previous video"
        ariaLabelNextTab="Go to next video"
        items={items}
        activeTabIndex={initTabIndex}
        setActiveTab={viewVideo}
        renderTabButton={renderVideo}
        leftAlign
        isCarousel
        {...responsiveTabsExtraProps}
      />
    </div>
  );
};

VideosCarousel.displayName = 'VideosCarousel';

VideosCarousel.propTypes = {
  items: PropTypes.array,
  activeResourceId: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
    .isRequired,
  onVideoChange: PropTypes.func,
  studentClasses: PropTypes.array,
  isTeacher: PropTypes.bool,
  isStudent: PropTypes.bool,
  subjectId: PropTypes.string.isRequired,
  filteredClasses: PropTypes.array,
};

VideosCarousel.defaultProps = {
  items: [],
  onVideoChange: () => {},
  studentClasses: [],
  isTeacher: false,
  isStudent: false,
  filteredClasses: [],
};

export default VideosCarousel;
